import { motion } from "framer-motion";
import { resolveImage } from "@/lib/api";

const RecipeCard = ({ recipe, index, onOpen }) => (
  <motion.button
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.55, delay: (index % 3) * 0.1 }}
    onClick={() => onOpen(recipe)}
    className="group text-left bg-white rounded-3xl overflow-hidden border border-[#1A1A1A]/5 shadow-[0_10px_30px_rgba(26,26,26,0.06)] hover:-translate-y-2 hover:shadow-[0_24px_44px_rgba(139,92,246,0.22)] transition-all duration-300 ease-out"
    data-testid={`recipe-card-${index}`}
  >
    <div className="relative h-52 overflow-hidden">
      {resolveImage(recipe.image_url) ? (
        <img src={resolveImage(recipe.image_url)} alt={recipe.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-[#8B5CF6] to-[#FF3D68]" />
      )}
      <span className="absolute top-3 left-3 bg-[#8B5CF6] text-white font-medium text-xs px-3 py-1 rounded-full shadow">Free Recipe</span>
    </div>
    <div className="p-6">
      <h3 className="font-display font-extrabold text-xl text-[#1A1A1A] leading-tight">{recipe.title}</h3>
      <p className="mt-2 text-[15px] text-[#1A1A1A]/70 leading-relaxed line-clamp-2">{recipe.description}</p>
      <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#8B5CF6] group-hover:gap-2.5 transition-all">
        View Recipe <span aria-hidden>→</span>
      </span>
    </div>
  </motion.button>
);

const FreeRecipes = ({ recipes, onOpen }) => (
  <section id="recipes" className="relative py-20 sm:py-28 scroll-mt-20 bg-white/60" data-testid="recipes-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-12 max-w-2xl"
      >
        <span className="font-display font-extrabold text-[#8B5CF6] text-sm tracking-[0.2em] uppercase">03 — On the House</span>
        <h2 className="mt-3 font-display font-extrabold text-4xl sm:text-5xl tracking-tight text-[#1A1A1A]">
          Free recipes to <span className="text-[#8B5CF6]">press at home</span>
        </h2>
        <p className="mt-4 text-lg text-[#1A1A1A]/70">Got a juicer? These are our house favorites — steal them, they're on us.</p>
      </motion.div>

      {recipes.length === 0 ? (
        <p className="text-[#1A1A1A]/50" data-testid="recipes-empty">Recipes coming soon!</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="recipes-grid">
          {recipes.map((r, i) => (
            <RecipeCard key={r.id} recipe={r} index={i} onOpen={onOpen} />
          ))}
        </div>
      )}
    </div>
  </section>
);

export default FreeRecipes;
